/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Nrl_Deletesuccess2Inputs */

const en_coinvestments_nrl_deletesuccess2 = /** @type {(inputs: Coinvestments_Nrl_Deletesuccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non-Release Letter removed successfully`)
};

/**
* | output |
* | --- |
* | "Non-Release Letter removed successfully" |
*
* @param {Coinvestments_Nrl_Deletesuccess2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_nrl_deletesuccess2 = /** @type {((inputs?: Coinvestments_Nrl_Deletesuccess2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Nrl_Deletesuccess2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_nrl_deletesuccess2(inputs)
});
export { coinvestments_nrl_deletesuccess2 as "coInvestments_nrl_deleteSuccess" }